import React from 'react'

export default function Tab({onClick,children,className}) {
  return (
    <div onClick={onClick} className={className}>{children}</div>
  )
}
